import { HubConnectionBuilder, LogLevel } from '@microsoft/signalr';
import { windowObject } from '../utils.js';
var EnterpriseEvents = /** @class */function () {
  function EnterpriseEvents() {
    var _this = this;
    this.env = "";
    this.hub = 'paymenthub';
    this.hubrout = function () {
      var _a, _b, _c, _d;
      return (((_a = windowObject === null || windowObject === void 0 ? void 0 : windowObject.location) === null || _a === void 0 ? void 0 : _a.hostname) || _this.env).indexOf("-dev") > -1 || (((_b = windowObject === null || windowObject === void 0 ? void 0 : windowObject.location) === null || _b === void 0 ? void 0 : _b.hostname) || _this.env).indexOf("localhost") > -1 ? "https://mypennymachub-dev.pennymac.com/".concat(_this.hub) : (((_c = windowObject === null || windowObject === void 0 ? void 0 : windowObject.location) === null || _c === void 0 ? void 0 : _c.hostname) || _this.env).indexOf("-qa") > -1 ? "https://mypennymachub-qa.pennymac.com/".concat(_this.hub) : (((_d = windowObject === null || windowObject === void 0 ? void 0 : windowObject.location) === null || _d === void 0 ? void 0 : _d.hostname) || _this.env).indexOf("-stg") > -1 ? "https://mypennymachub-stg.pennymac.com/".concat(_this.hub) : "https://mypennymachub.pennymac.com/".concat(_this.hub);
    };
    this.initiate = function () {
      _this.connection = new HubConnectionBuilder().withUrl(_this.hubrout(), {
        accessTokenFactory: function () {
          return EnterpriseEvents.token;
        },
        headers: {
          "Allow-Control-Allow-Origin": "*"
        }
      }).withAutomaticReconnect({
        nextRetryDelayInMilliseconds: function (retryContext) {
          if (retryContext.elapsedMilliseconds < 60000) {
            // If we've been reconnecting for less than 60 seconds so far,
            // wait between 0 and 10 seconds before the next reconnect attempt.
            return Math.random() * 10000;
          } else {
            // If we've been reconnecting for more than 60 seconds so far, stop reconnecting.
            return null;
          }
        }
      }).configureLogging(LogLevel.Debug).build();
      _this.connection.on("ReceiveMessage", function (message, mdat) {
        if (typeof EnterpriseEvents.callBack == "function") {
          EnterpriseEvents.callBack(message, "ReceiveMessage");
        }
      });
      _this.connection.on("InternalMessage", function (message) {
        if (typeof EnterpriseEvents.callBack == "function") {
          EnterpriseEvents.callBack(message, "InternalMessage");
        }
      });
      _this.connection.on("FeatureToggle", function (message) {
        if (typeof EnterpriseEvents.callBack == "function") {
          EnterpriseEvents.callBack(message, "FeatureToggle");
        }
      });
      var start = function () {
        console.log("Connection Invoked");
        _this.connection.start().then(function () {
          console.log("Connection Made");
        }).catch(function (err) {
          console.log("Connection Error", err);
          // start()
          return console.log(err.toString());
        });
      };
      start();
      _this.connection.onclose(function () {
        console.log("Connection Closed");
        start();
      });
    };
    this.init = function (func, token) {
      EnterpriseEvents.callBack = func;
      EnterpriseEvents.token = token;
      if (!_this.connection) {
        _this.initiate();
      }
    };
    this.postEvent = function (message, userid) {
      _this.connection.invoke("SendMessage", message, userid).catch(function (err) {
        return console.error(err.toString());
      });
    };
  }
  return EnterpriseEvents;
}();
export default new EnterpriseEvents();